import API from 'utils/api';
import { onSuccess, onError } from 'utils/handlers';

export const baseURI = 'configuracion/subunidades-de-recaudacion/';

/**
 * GET Sub Unidades de Recaudación
 * @returns {Promise<Array<object>>}
 */
export const getSubUnidadesDeRecaudacion = async (params) => {
  try {
    const response = await API.get(baseURI, { params });
    return response.data;
  } catch (err) {
    onError(err);
    return [];
  }
};

/**
 * GET Sub Unidad de Recaudación
 * @param {number} id
 * @returns {Promise<object>}
 */
export const getSubUnidadDeRecaudacion = async (id) => {
  try {
    const response = await API.get(`${baseURI}${id}`);
    return response.data;
  } catch (err) {
    onError(err);
    return null;
  }
};

/**
 * POST Unidad de Recaudación
 * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const postSubUnidadDeRecaudacion = async (values) => {
  try {
    const response = await API.post(baseURI, values);
    onSuccess(response, 'Agregado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * PATCH Unidad de Recaudación
 * @param {number} id
 * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const patchSubUnidadDeRecaudacion = async (id, values) => {
  try {
    const response = await API.patch(`${baseURI}${id}`, values);
    onSuccess(response, 'Editado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * DELETE Unidad de Recaudación
 * @param {number} id
 * @returns {Promise<object|boolean>}
 */
export const deleteSubUnidadDeRecaudacion = async (id) => {
  try {
    const response = await API.delete(`${baseURI}${id}`);
    onSuccess(response, 'Eliminado correctamente');
    return true;
  } catch (err) {
    onError(err);
    return false;
  }
};
